export function FlagSkeletonRow() {
  return (
    <div className="caddietw-flex caddietw-items-center caddietw-justify-between caddietw-py-2.5 caddietw-px-3">
      <div>
        <div className="caddietw-h-4 caddietw-w-32 caddietw-bg-gray-200 caddietw-rounded caddietw-animate-pulse caddietw-mb-1" />
        <div className="caddietw-h-3 caddietw-w-24 caddietw-bg-gray-100 caddietw-rounded caddietw-animate-pulse" />
      </div>
      <div className="caddietw-h-5 caddietw-w-9 caddietw-bg-gray-200 caddietw-rounded-full caddietw-animate-pulse" />
    </div>
  );
}
